const departments = {
    leader: 'Sorumlu',
    leaders: 'Bölüm sorumluları',
    led_departments: 'Yönettiğiniz bölümler',
    edit_leaders: 'Sorumluları yönet',
    add_leader: 'Ekle',
    remove_leader: 'Kaldır',
    no_leaders: 'Sorumlu atanmamış',
    local: 'Yerel yönetim',
    managed_members: 'Yönetim kapsamındaki üyeler',
    leader_scope_hint: 'Bölümlerinizdeki ve alt bölümlerdeki üyelikleri yönetin.',
    leader_permission_hint: 'Sorumlular kendi bölümleri ve alt bölümlerdeki üyelikleri yönetir; kuruluş rollerini veya hiyerarşiyi değiştiremez.',
    primary_synced: 'Ana bölüm Feishu tarafından yönetilir.',
    status_active: 'Etkin',
    status_suspended: 'Askıya alındı',
    status_departed: 'Ayrıldı',
    status_pending: 'Etkinleştirme bekliyor',
    search: 'Ara',
    previous_page: 'Önceki sayfa',
    next_page: 'Sonraki sayfa',
    directory_title: 'Kuruluş üyeleri',
    member_name: 'Üye',
    search_members: 'Ada veya kullanıcı adına göre ara',
    include_descendants: 'Alt bölümleri dahil et',
    no_members: 'Eşleşen üye yok.',
    all_members: 'Tüm üyeler',
    all_departments: 'Tüm bölümler',
    edit_member: 'Bölümleri düzenle',
    add_child: 'Alt bölüm ekle',
    expand_department: '{{name}} genişlet',
    collapse_department: '{{name}} daralt',
    title: 'Departmanlar',
    description: 'Bu kuruluşun departmanlarını ve üye atamalarını yönetin.',
    create: 'Departman oluştur',
    edit: 'Departmanı düzenle',
    name: 'Departman adı',
    parent: 'Üst departman',
    root: 'Üst departman yok',
    id: 'Departman kimliği',
    members: 'Üyelerin departmanları',
    member_id: 'Üye kullanıcı kimliği',
    primary: 'Birincil departman',
    none: 'Ayarlanmadı',
    assignments: 'Departman atamaları',
    no_assignments: 'Henüz departman ataması yok.',
    assignment_hint: 'Yerel departmanları ve isteğe bağlı birincil departmanı atayın. Dizin atamaları salt okunurdur.',
    empty: 'Henüz departman yok.',
    readonly: 'Departmanları ve atamalarınızı görebilirsiniz. Değişiklik için kuruluş yöneticisine başvurun.',
    load_error: 'Veriler yüklenemedi. Yeniden deneyin.',
    mutation_error: 'Kaydedilemedi. İzinleri, üyeliği ve departman hiyerarşisini kontrol edin.',
    loading: 'Yükleniyor…',
    synced: 'Dizin tarafından yönetiliyor',
    choose: 'Departman ara',
    organizations_title: 'Kuruluşlar ve departmanlar',
    organizations_description: 'Departmanlarını görmek veya yönetmek için bir kuruluş seçin.',
    no_organizations: 'Bir kuruluşa üye değilsiniz. Yöneticinizle iletişime geçin.',
    organization: 'Geçerli kuruluş',
    choose_organization: 'Kuruluş seçin',
    delete_title: 'Departmanı sil',
    delete_description: '“{{name}}” silinsin mi? Önce üyeleri ve alt departmanları taşıyın.',
};
export default Object.freeze(departments);
